<div class="o-grid">
    <div class="o-grid__cell o-grid__cell--w-100">
        <div style="min-height:50vh;" class="c-card">
            <div style="height:100%" class="c-content c-content--xxl">
                <div style="height:100%" class="o-grid o-grid--wrap u-ost-sm u-osb-sm">
                    <div class="c-content--push-right@xl-and-up o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--o2@up-to-md u-ost-md@up-to-md">
                        <p class="c-text c-text--s12 c-text--bold u-ost-sm u-osb-sm">{{ 'MyMentalProfile.Title' | translate }}</p>
                        <p class="c-text c-text--spaced c-text--wrap">{{vm.infoText}}&nbsp;<a [routerLink]="['/mental-health-services']">{{ 'Common.Back' | translate }}</a></p>

                        <p style="padding-top:40px;padding-bottom:10px;" class="c-text c-text--spaced c-text--wrap">{{ 'Common.Download_App' | translate }}</p>
                        <div class="o-grid o-grid--center-v" *ngIf="vm.appLogoLang">
							<div style="padding-left:0px !important;" class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
								<a href="{{vm.iosLink}}" target="_blank" rel="noreferrer noopener" class="c-header__btn"> <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/header/app-store-en.png" alt="App Store">
								</a>
							</div>
							<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
								<a href="{{vm.androidLink}}" target="_blank" rel="noreferrer noopener" class="c-header__btn"> <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/header/google-play-en.png"
									alt="Google Play">
								</a>
							</div>
						</div>
					</div>
                    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-no-p o-grid__cell--o1@up-to-md u-hidden@up-to-md">
                        <div class="o-grid o-grid--wrap">
                            <img style="position:absolute;height:74%;padding-top:40px;padding-left:230px;" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/my-mental-profile-android.png">
                            <img style="position:absolute;height:85%;padding-left:80px;" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/my-mental-profile-iphone.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
